module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/clock_and_phone-e0ec28c52f50e5013387b82391340a87.png";